import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import * as $ from 'jquery';
import * as NoUiSlider from 'nouislider';

export class SliderTypeFilters extends SubmittableFilter {
  protected static readonly Selector = {
    FILTER_SLIDER_ITEM: ".js_filter_slider_item",
    SLIDER_ITSELF: ".js_filter_slider",
  };

  public static init() {
    $(this.Selector.FILTER_SLIDER_ITEM).each((index, filterSliderElement) => {
      const sliderElementItself = $(filterSliderElement).find(
        this.Selector.SLIDER_ITSELF
      ).get(0);
      const { selectedMax, selectedMin, range, elements } = this.extractDataFromElement(filterSliderElement);

      const sliderInstance = NoUiSlider.create(sliderElementItself, {
        start: [selectedMin, selectedMax],
        connect: true,
        range: {
          min: [range.min],
          max: [range.max],
        },
      });

      // Disable slider since there is no point in using it if there is only one value
      if (range.min === range.max) {
        sliderInstance.disable();
      }

			this.declareEventListeners(elements, sliderInstance);
    });
  }

	/**
	 * Declares event listeners for slider and input elements
	 * It couldn't be done by using normal events, because elements
	 * needed to be extracted from the instance first, so it's done in this method
	 */
  private static declareEventListeners(
    elements: { minInput: JQuery<HTMLElement>; maxInput: JQuery<HTMLElement> },
    sliderInstance: NoUiSlider.API
  ) {
    elements.minInput.on("change", (event) => this.handleInputChange(event.target, sliderInstance));
    elements.maxInput.on("change", (event) => this.handleInputChange(event.target, sliderInstance));
    sliderInstance.on("update", (newValues: [string, string]) => {
			this.handleSliderUpdate(newValues, elements)
		});
		sliderInstance.on("change", (newValues: [string, string]) => {
			this.handleSliderUpdate(newValues, elements)
		});
  }

  private static extractDataFromElement(element: HTMLElement) {
    let minInput = $(element).find(".range-products-min");
    let dataMin = parseFloat(minInput.data("min"));
    let minValue = parseFloat(minInput.val() as string);

    if (isNaN(minValue)) {
      minValue = dataMin;
    }

    let maxInput = $(element).find(".range-products-max");
    let dataMax = parseFloat(maxInput.data("max"));
    let maxValue = parseFloat(maxInput.val() as string);

    if (isNaN(maxValue)) {
      maxValue = dataMax;
    }

    if (minValue >= maxValue) {
      minValue--;
    }

    return {
      selectedMin: minValue,
      selectedMax: maxValue,
      range: {
        min: dataMin,
        max: dataMax,
      },
      elements: {
        minInput,
        maxInput,
      },
    };
  }

  private static handleSliderUpdate(
		[newMinValue, newMaxValue]: [string, string],
		elements: { minInput: JQuery<HTMLElement>; maxInput: JQuery<HTMLElement> },
	) {
    let parsedNewMinValue = parseFloat(newMinValue);
    let parsedNewMaxValue = parseFloat(newMaxValue);

    const currentMinValue = parseFloat(elements.minInput.val() as string);
    const currentMaxValue = parseFloat(elements.maxInput.val() as string);

    // Update ALL duplicate inputs with the same name, not just this one
    const minInputName = elements.minInput.attr('name');
    const maxInputName = elements.maxInput.attr('name');
    
    if (minInputName) {
      $(`[name="${minInputName}"]`).val(parsedNewMinValue);
    }
    if (maxInputName) {
      $(`[name="${maxInputName}"]`).val(parsedNewMaxValue);
    }

    // Then check if we should mark them as ready to submit (only the one in normal section)
    if (currentMinValue && currentMinValue !== parsedNewMinValue) {
      if (this.shouldMarkAsReadyToSubmit(elements.minInput as JQuery<HTMLInputElement>)) {
        this.applyReadyToBeSubmittedClass(elements.minInput as JQuery<HTMLInputElement>);
      }
    }

    if (currentMaxValue && currentMaxValue !== parsedNewMaxValue) {
      if (this.shouldMarkAsReadyToSubmit(elements.maxInput as JQuery<HTMLInputElement>)) {
        this.applyReadyToBeSubmittedClass(elements.maxInput as JQuery<HTMLInputElement>);
      }
    }
  }

  private static handleInputChange(
    eventTarget: HTMLElement,
    sliderInstance: NoUiSlider.API
  ) {
    const thisInputAsWholeFilterElement = $(eventTarget).parentsUntil(this.Selector.FILTER_SLIDER_ITEM);

    const minValue = parseFloat(
			thisInputAsWholeFilterElement.children(".range-products-min").val() as string
		);
    const maxValue = parseFloat(
      thisInputAsWholeFilterElement.children(".range-products-max").val() as string
    );

    sliderInstance.set([minValue, maxValue]);
    const input = $(eventTarget) as JQuery<HTMLInputElement>;
    if (this.shouldMarkAsReadyToSubmit(input)) {
      this.applyReadyToBeSubmittedClass(input);
    }
  }

  /**
   * Checks if the input should be marked as ready to submit.
   * Only inputs in the normal filters section should be marked, not duplicates in the side panel.
   * This prevents duplicate filters from interfering with each other.
   */
  protected static shouldMarkAsReadyToSubmit(input: JQuery<HTMLInputElement>): boolean {
	  const isInNormalSection = input.closest('.js_normal_filters_section').length > 0;
	  const isInSideSection = input.closest('.js_filters_moreFiltersSideSection').length > 0;
	  return isInNormalSection || isInSideSection;
  }

  protected static applyReadyToBeSubmittedClass(input: JQuery<HTMLInputElement>) {
    input.addClass(this.readyToBeSubmittedClass);
  }
}
import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import * as $ from 'jquery';
import * as NoUiSlider from 'nouislider';

export class SliderTypeFilters extends SubmittableFilter {
  protected static readonly Selector = {
    FILTER_SLIDER_ITEM: ".js_filter_slider_item",
    SLIDER_ITSELF: ".js_filter_slider",
  };

  public static init() {
    $(this.Selector.FILTER_SLIDER_ITEM).each((index, filterSliderElement) => {
      const sliderElementItself = $(filterSliderElement).find(
        this.Selector.SLIDER_ITSELF
      ).get(0);
      const { selectedMax, selectedMin, range, elements } = this.extractDataFromElement(filterSliderElement);

      const sliderInstance = NoUiSlider.create(sliderElementItself, {
        start: [selectedMin, selectedMax],
        connect: true,
        range: {
          min: [range.min],
          max: [range.max],
        },
      });

      // Disable slider since there is no point in using it if there is only one value
      if (range.min === range.max) {
        sliderInstance.disable();
      }

			this.declareEventListeners(elements, sliderInstance);
    });
  }

	/**
	 * Declares event listeners for slider and input elements
	 * It couldn't be done by using normal events, because elements
	 * needed to be extracted from the instance first, so it's done in this method
	 */
  private static declareEventListeners(
    elements: { minInput: JQuery<HTMLElement>; maxInput: JQuery<HTMLElement> },
    sliderInstance: NoUiSlider.API
  ) {
    elements.minInput.on("change", (event) => this.handleInputChange(event.target, sliderInstance));
    elements.maxInput.on("change", (event) => this.handleInputChange(event.target, sliderInstance));
    sliderInstance.on("update", (newValues: [string, string]) => {
			this.handleSliderUpdate(newValues, elements)
		});
		sliderInstance.on("change", (newValues: [string, string]) => {
			this.handleSliderUpdate(newValues, elements)
		});
  }

  private static extractDataFromElement(element: HTMLElement) {
    let minInput = $(element).find(".range-products-min");
    let dataMin = parseFloat(minInput.data("min"));
    let minValue = parseFloat(minInput.val() as string);

    if (isNaN(minValue)) {
      minValue = dataMin;
    }

    let maxInput = $(element).find(".range-products-max");
    let dataMax = parseFloat(maxInput.data("max"));
    let maxValue = parseFloat(maxInput.val() as string);

    if (isNaN(maxValue)) {
      maxValue = dataMax;
    }

    if (minValue >= maxValue) {
      minValue--;
    }

    return {
      selectedMin: minValue,
      selectedMax: maxValue,
      range: {
        min: dataMin,
        max: dataMax,
      },
      elements: {
        minInput,
        maxInput,
      },
    };
  }

  private static handleSliderUpdate(
		[newMinValue, newMaxValue]: [string, string],
		elements: { minInput: JQuery<HTMLElement>; maxInput: JQuery<HTMLElement> },
	) {
    let parsedNewMinValue = parseFloat(newMinValue);
    let parsedNewMaxValue = parseFloat(newMaxValue);

    const currentMinValue = parseFloat(elements.minInput.val() as string);
    const currentMaxValue = parseFloat(elements.maxInput.val() as string);

    // Update ALL duplicate inputs with the same name, not just this one
    const minInputName = elements.minInput.attr('name');
    const maxInputName = elements.maxInput.attr('name');
    
    if (minInputName) {
      $(`[name="${minInputName}"]`).val(parsedNewMinValue);
    }
    if (maxInputName) {
      $(`[name="${maxInputName}"]`).val(parsedNewMaxValue);
    }

    // Then check if we should mark them as ready to submit (only the one in normal section)
    if (currentMinValue && currentMinValue !== parsedNewMinValue) {
      if (this.shouldMarkAsReadyToSubmit(elements.minInput as JQuery<HTMLInputElement>)) {
        this.applyReadyToBeSubmittedClass(elements.minInput as JQuery<HTMLInputElement>);
      }
    }

    if (currentMaxValue && currentMaxValue !== parsedNewMaxValue) {
      if (this.shouldMarkAsReadyToSubmit(elements.maxInput as JQuery<HTMLInputElement>)) {
        this.applyReadyToBeSubmittedClass(elements.maxInput as JQuery<HTMLInputElement>);
      }
    }
  }

  private static handleInputChange(
    eventTarget: HTMLElement,
    sliderInstance: NoUiSlider.API
  ) {
    const thisInputAsWholeFilterElement = $(eventTarget).parentsUntil(this.Selector.FILTER_SLIDER_ITEM);

    const minValue = parseFloat(
			thisInputAsWholeFilterElement.children(".range-products-min").val() as string
		);
    const maxValue = parseFloat(
      thisInputAsWholeFilterElement.children(".range-products-max").val() as string
    );

    sliderInstance.set([minValue, maxValue]);
    const input = $(eventTarget) as JQuery<HTMLInputElement>;
    if (this.shouldMarkAsReadyToSubmit(input)) {
      this.applyReadyToBeSubmittedClass(input);
    }
  }

  /**
   * Checks if the input should be marked as ready to submit.
   * Only inputs in the normal filters section should be marked, not duplicates in the side panel.
   * This prevents duplicate filters from interfering with each other.
   */
  protected static shouldMarkAsReadyToSubmit(input: JQuery<HTMLInputElement>): boolean {
	  const isInNormalSection = input.closest('.js_normal_filters_section').length > 0;
	  const isInSideSection = input.closest('.js_filters_moreFiltersSideSection').length > 0;
	  return isInNormalSection || isInSideSection;
  }

  protected static applyReadyToBeSubmittedClass(input: JQuery<HTMLInputElement>) {
    input.addClass(this.readyToBeSubmittedClass);
  }
}
